function applyDiscount() {
   var discountCode = document.getElementById('discount_code').value;

   if (!discountCode) {
      document.getElementById('discount-message').innerText = "Bitte einen Rabattcode eingeben.";
      return;
   }

   fetch(`/discount/${discountCode}`)
      .then(response => {
         if (response.redirected) {
            // Wenn erfolgreich, leite zur Warenkorbseite weiter
            window.location.href = "/cart";
         } else {
            document.getElementById('discount-message').innerText = "Ungültiger Rabattcode.";
         }
      })
      .catch(error => {
         console.error("Fehler beim Anwenden des Rabattcodes:", error);
         document.getElementById('discount-message').innerText = "Ein Fehler ist aufgetreten. Bitte versuche es erneut.";
      });
}
